import { post, get } from './httpClient'

export const addSite = (body) => post('/site/createsite', { ...body })
export const updateSite = (body) => post('/site/updatesite', { ...body })
export const getSites = (params) => get('/site/getallsite', { ...params })
export const searchSites = (object) => get('/site/getallsite', object)
export const removeSite = (_id) => post('/site/removesite', { _id })
export const verifyApp = (path, params, endpoint) =>
  get(path, params, undefined, endpoint)
export const assignDesigner = (body) => post('/site/assignuser', body)
export const removeDesigner = (body) => post('/site/removeassign', body)

// Etsy Extension credential management
export const listCredentials = (siteId) => get(`/etsy-extension/credentials/${siteId}`)
export const regenerateSecret = (body) => post('/etsy-extension/regenerate-secret', body)
export const generateToken = (body) => post('/etsy-extension/generate-token', body)
export const revokeToken = (body) => post('/etsy-extension/revoke-token', body)

// GA4 Settings (per phase-04 v2 — OAuth pivot)
export const getGa4Config = (site_id) => get('/site/ga4-config/get', { site_id })
export const initGa4OAuth = (body) => post('/site/ga4-config/oauth-init', body)
export const listGa4Properties = (body) => post('/site/ga4-config/list-properties', body)
export const addGa4Property = (body) => post('/site/ga4-config/properties', body)
export const removeGa4Property = (body) => post('/site/ga4-config/properties/remove', body)
export const setGa4DefaultProperty = (body) => post('/site/ga4-config/default-property', body)
export const setGa4Enabled = (body) => post('/site/ga4-config/enabled', body)
export const disconnectGa4 = (site_id) => post('/site/ga4-config/disconnect', { site_id })
export const testGa4Connection = (body) => post('/site/ga4-config/test-connection', body)
